import { Typography } from "@mui/material";
import {
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";
import ConversionsFilter from "./ConversionsFilter";
import ConversionsTableItem from "./ConversionsTableItem";

const monthTableHeadings = {
  date: "",
  total_FTD: "Loaded / Total FTD",
  total_QFTD: "Loaded / Total QFTD",
};

const ConversionsTable = () => {
  return (
    <>
      <ConversionsFilter />
      <Typography
        sx={{
          fontWeight: typography.Font_weight.Medium.$value,
          color: colors.GrayLightMode[900].$value,
          my: 1,
        }}
      >
        Conversion Upload
      </Typography>
      <ConversionsTableItem
        monthTableHeadings={monthTableHeadings}
      />
    </>
  );
};

export default ConversionsTable;
